var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{ref:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"checkmark"}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }